import { TableRow } from "@material-ui/core";
import { withStyles, Theme, createStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#FAFAFA",
      color: theme.palette.common.black,
      fontSize: "1rem",
      fontWeight: "bold",
      padding: "1rem 0.5rem",
    },
    body: {
      fontSize: 14,
      padding: "0 0.5rem",
      width: "3.5rem",
      maxWidth: "3.5rem",
    },
  })
)(TableCell);

export const HeadRow = withStyles(() =>
  createStyles({
    head: {
      position: "sticky",
      top: 0,
      zIndex: 10,
    },
  })
)(TableRow);

export default StyledTableCell;
